export const jsonStringifyReplacer = (_, value) => {
    if (typeof value === 'bigint') {
        return value.toString();
    }
    return value;
};
export function joinValues(array, separator = ' | ') {
    return array
        .map((val) => (typeof val === 'string' ? `'${val}'` : val))
        .join(separator);
}
